import { Directive } from "vue";

const resizeObserver = new ResizeObserver(entries => {
  entries.forEach(entry => resizeCallbacks.get(entry.target)?.(entry));
});
const resizeCallbacks = new Map();

const resizeListener: Directive<
  HTMLElement,
  (size: ResizeObserverEntry) => void
> = {
  mounted(el, binding) {
    resizeCallbacks.set(el, binding.value);
    resizeObserver.observe(el);
  },

  beforeUnmount(el) {
    resizeObserver.unobserve(el);
    resizeCallbacks.delete(el);
  }
};

export default resizeListener;
